import { canEnableSessionSwitch } from "dashboard-utils/lib/utils/merchantSession";
import { MENUS_ITEMS, MENU_ITEM_IDENTIFIERS } from "../constants/global";
import {
  sessionSwitcherEnabled,
  getConsolidatedUsersDetails,
  getSelectedConsolidatedMids,
  isConsolidatedDashboard,
} from "dashboard-utils";
import { CURRENCY_SIGN } from "dashboard-utils/lib/constants";

export const getMidSwitcherOptions = (merchantParams) => {
  const mids = getSelectedConsolidatedMids();
  const allMids = getConsolidatedUsersDetails();
  return allMids
    .map((user) => {
      return {
        checked: mids.length > 0 && mids.includes(user.identifier),
        label: `${user.identifier} - ${user.name}`,
        value: user.identifier,
        subLabel: merchantParams?.isMccAccount ? `${merchantParams.currencyMidMap[user.identifier]} ${CURRENCY_SIGN[merchantParams.currencyMidMap[user.identifier]]}`: null
      };
    })
    .filter(Boolean);
};

export const isDataPlatfromAccessEnabled = (attachedConfigs = []) => {
  return (
    attachedConfigs.find(
      (config) => config.name === "lookup_platform_access_config"
    )?.config?.on_one_dashboard?.access_enabled || false
  );
};
export const isThirdPartyAndSettlementActive = (merchantDetails) => {
  return (
    merchantDetails?.integrationType == "ThirdParty" &&
    merchantDetails?.onboardingResponse?.settlement_status == "Active"
  );
};
export const isAdminOrAdministratorRole = (merchantDetails) => {
  return (
    merchantDetails?.onboardingResponse?.acl_role_name ===
      "MerchantAdminUserRole" ||
    merchantDetails?.onboardingResponse?.acl_role_name === "Administrator"
  );
};
export const getLoginToBizForm = (merchantMID, authToken) => {
  return `<style>#submit{visibility: hidden;}</style><html><body>
  Loading... <form method="post" action="https://info.payu.in/merchant/loginSmbMerchant" name="frm1">
      <input type="hidden" name="authToken" value=${authToken} />
      <input type="hidden" name="merchantId" value=${merchantMID} />
      <input type="submit" name="submit" id="submit" style="visibility:none"/> 
    </form><script>document.getElementsByName("submit")[0].click();</script>
    </body></html>`;
};
export const getMenus = ({
  appName = "@one-dash/txns",
  merchantInfo = {},
  isMobile = false,
  showSwitchMid,
  merchantParams
} = {}) => {
  switch (appName) {
    case "@one-dash/data-platform":
      return getDataPlatformMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/switch-pay":
      return getSwitchPayMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/txns":
      return getTxnsMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/front-office":
      return getLaunchpadMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/tools":
      return getToolsMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/aggregator":
      return getAggregatorMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@neo-dash/lending":
      return getLendingMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/offerDashboard":
      return getOfferEngineMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/widget":
      return getWidgetMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    case "@one-dash/payouts":
      return getPayoutMenus(merchantInfo, isMobile, showSwitchMid, merchantParams);
    default:
      return {
        mainMenus: [],
        userMenu: {},
      };
  }
};

const defaultUserMenu = {
  ...MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.USER_MENU],
  classes: { containerClassName: "border-left" },
  menuItems: [
    isConsolidatedDashboard ? null : MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.ONBOARDING_PROFILE],
    isConsolidatedDashboard ? null : MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.DASHBOARD_SETTINGS],
    {
      ...MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.USER_LOGOUT],
      placement: "footer",
      iconProps: {},
    },
  ].filter(Boolean),
};

const getDefaultMenu = (isMobile, showSwitchMid) => {
  if (isMobile) {
    defaultUserMenu.menuItems.unshift(
      MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.SF_CHAT_BUTTON]
    );
  }
  if(showSwitchMid) {
    const present = defaultUserMenu.menuItems.find((m) => m.identifier === MENU_ITEM_IDENTIFIERS.SWITCH_TO_DIFF_MID);
    if(!present) {
      defaultUserMenu.menuItems.push(
        MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.SWITCH_TO_DIFF_MID],
      );
    }
  }
  return defaultUserMenu;
};

const isSessionSwticherEnabled = sessionSwitcherEnabled();

// const canEnableSessionSwitcher = canEnableSessionSwitch();
const canEnableSessionSwitcher = false;

export const getTxnsMenus = (merchantInfo, isMobile, showSwitchMid, merchantParams) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  if (isDataPlatfromAccessEnabled(merchantInfo?.attachedConfigs)) {
    mainMenus.push(MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.ANALYTICS]);
  }
  let userMenu = {
    ...MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.USER_MENU],
    menuItems: [
      isConsolidatedDashboard ? null : MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.ONBOARDING_PROFILE],
      isConsolidatedDashboard ? null : MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.DASHBOARD_SETTINGS],
      showSwitchMid ? MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.SWITCH_TO_DIFF_MID] : null,
    ].filter(Boolean),
  };
  if (isMobile) {
    userMenu.menuItems.unshift(
      MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.SF_CHAT_BUTTON]
    );
  }
  if (merchantParams?.switchToPayuBiz === "1" &&
    isThirdPartyAndSettlementActive(merchantInfo) &&
    isAdminOrAdministratorRole(merchantInfo)
  ) {
    userMenu.menuItems.push(
      MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.SWITCH_TO_BIZ_DASHBOARD]
    );
  }
  userMenu.menuItems.push({
    ...MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.USER_LOGOUT],
    placement: "footer",
    iconProps: {},
  });
  return { mainMenus, userMenu, isSessionSwticherEnabled, canEnableSessionSwitcher };
};

export const getLaunchpadMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled,
    canEnableSessionSwitcher
  };
};

export const getToolsMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled,
    canEnableSessionSwitcher
  };
};

export const getAggregatorMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled,
    canEnableSessionSwitcher
  };
};

export const getOfferEngineMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled: false,
    canEnableSessionSwitcher: false
  };
};

export const getWidgetMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled: false,
    canEnableSessionSwitcher: false
  };
};

export const getDataPlatformMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [
    MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP],
    MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.BUSINESS_DASHBOARD],
  ];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled,
    canEnableSessionSwitcher
  };
};

export const getLendingMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled,
    canEnableSessionSwitcher
  };
};

export const getPayoutMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP]];
  return {
    mainMenus,
    userMenu: getDefaultMenu(isMobile, showSwitchMid),
    isSessionSwticherEnabled,
    canEnableSessionSwitcher
  };
};

export const getSwitchPayMenus = (merchantInfo, isMobile, showSwitchMid) => {
  let mainMenus = [
    MENUS_ITEMS[MENU_ITEM_IDENTIFIERS.HELP],
  ];
  return { mainMenus, userMenu: getDefaultMenu(isMobile, showSwitchMid), isSessionSwticherEnabled, canEnableSessionSwitcher };
};
